export default __webpack_public_path__ + "static/media/avatar9.e4c94007.png";